import React from 'react'
import { IIconProps } from './types'

const IconHammerScrewdriver: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '24px'}
        width={props.width ? props.width : '24px'}
        fill={props.color ? props.color : '#000000'}
        viewBox='0 0 24.913 28'
      >
        <path
          id='hammer-screwdriver'
          d='M22.94,18.635l8.445,8.385-4.98,4.92L18.02,23.555v-1.38l3.54-3.54h1.38m1.365-3.8L22.85,13.4l-7.185,7.2v2.955L7.22,32,2.3,27.02l8.385-8.385H13.64l1.17-1.17L9.05,11.69H7.1L2.885,7.43,6.815,3.5l4.2,4.2V9.665l5.835,5.76,3.99-3.99L19.4,9.92l1.95-1.965H17.36l-.975-.975L21.35,2l.99.99V6.98L24.3,5l4.92,4.92a4.246,4.246,0,0,1,0,5.97L26.27,12.875Z'
          transform='translate(-2.3 -2)'
          fill={props.color ? props.color : '#1b1b1d'}
        />
      </svg>
    </>
  )
}

export default IconHammerScrewdriver
